SupportHorizontalViewManagerBase = require('../horizontal_view_manager_base')
SupportV2StepOneView = require('../../views/step_one/v2_view')
SupportV2StepActionsModel = require('../../models/v2_step_action')
SupportV2USStepThreeView = require('../../views/step_three/US/v2_view')
SharedFooterUSMainView = require('../../../../shared/frontend/views/footer/US/main_view')
StepTwoInbentaNLPView = require('../../views/step_two/inbenta/nlp_view')
StepTwoInbentaNonNLPView = require('../../views/step_two/inbenta/non_nlp_view')
StepTwoV1CMSView = require('../../views/step_two/CMS/v1_cms_view')
SupportInbentaModel = require('../../models/Inbenta')
SupportCMSModel = require('../../models/CMS')
SupportV2OptimizedContactChannelsModel = require('../../models/v2_optimized_contact_channels')

class SupportV2USViewManager extends SupportHorizontalViewManagerBase
  constructor: () ->
    SupportHorizontalViewManagerBase::constructor.apply(this, arguments)
    Groupon.Support.stepActionModel = new SupportV2StepActionsModel({
      showHorizontalView: true
    })

  render: () ->
    @renderFooter()

  renderFooter: ->
    supportFooter = new SharedFooterUSMainView()
    supportFooter.render()
    $("#footer-content").html(supportFooter.el)
    addWrapperLinkOverCallUs()

  getStepOneView: ->
    new SupportV2StepOneView({
      showHorizontalView: true
    })

  getStepTwoView: ->
    Groupon.Support.StepTwoView = if isCMSEnabled()
       new StepTwoV1CMSView({
         dropDownModel: Groupon.Support.ContentModel.dropDowns
       })
    else
      if Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()
        inbentaView = StepTwoInbentaNLPView
      else
        inbentaView = StepTwoInbentaNonNLPView

      new inbentaView({
        dropDownModel: Groupon.Support.ContentModel.dropDowns
        dropDownCombinationsModel: Groupon.Support.ContentModel.dropDownCombinations
      })

  getStepThreeView: ->
    new SupportV2USStepThreeView()

  configureContentModel: ->
    if isCMSEnabled()
      Groupon.Support.ContentModel = new SupportCMSModel
    else
      Groupon.Support.ContentModel = new SupportInbentaModel

  configureOptimizedContactChannelsModel: ->
    Groupon.Support.OptimizedContactChannelsModel = new SupportV2OptimizedContactChannelsModel

module.exports = SupportV2USViewManager
